import { Stack, styled } from "@mui/material";

export const TelegramPattern = styled(Stack)`
  background-color: #010101;
  background-image: url("/static/img/content/telegram_pattern_1.webp"),
    linear-gradient(194.04deg, #53beb8 0%, #65a8e9 100%);
`;
